import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const InputContainerStyled = styled.div`
  display: flex;
  flex-flow: column;
`;

export const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${ct({ Light: Colors.RedMiddle, Dark: Colors.RedMiddle })};
`;
